import type { GiftPassDetail } from '../../api/gift-passes';

import { GIFT_PASS_SOURCE_LABEL } from './gift-passes-model';
import { GiftPassBookingValue } from './GiftPassBookingValue';
import { GiftPassCompRows } from './GiftPassCompRows';
import { GiftPassOrderRows } from './GiftPassOrderRows';

export function GiftPassOriginFields({ pass }: { pass: GiftPassDetail }) {
  return (
    <dl className="gp-field-list gp-section">
      <dt>Origin</dt>
      <dd style={{ fontWeight: 700 }}>{GIFT_PASS_SOURCE_LABEL[pass.source]}</dd>
      {pass.order && <GiftPassOrderRows order={pass.order} />}
      {pass.refundedBooking && (
        <>
          <dt>Refunded booking</dt>
          <dd>
            <GiftPassBookingValue booking={pass.refundedBooking} />
          </dd>
        </>
      )}
      {pass.taxPrepaid && (
        <>
          <dt>Tax</dt>
          <dd style={{ fontWeight: 700 }}>Prepaid on the original booking</dd>
        </>
      )}
      {pass.comp && <GiftPassCompRows comp={pass.comp} />}
    </dl>
  );
}
